import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { approveContractVm } from 'src/app/models/approveContractVm';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenService } from 'src/app/services/token.service';

@Component({
  selector: 'app-view-expressapproval',
  templateUrl: './view-expressapproval.component.html',
  styleUrls: ['./view-expressapproval.component.css']
})
export class ViewExpressApprovalComponent implements OnInit {

  ViewRequestVisible = false;
  ApproveRequest: ContractDto | any

  isApproveConfirmationModalVisible: boolean = false;
  isRejectConfirmationModalVisible: boolean = false;
  isProcessing: boolean = false

  currentUser: any

  showCreatedByColumn: boolean = false;
  showFunctionColumn: boolean = false;

  constructor(private contractService: ContractsService, private notification: NotificationService,
    private tokenService: TokenService) { }

  Contracts: ContractDto[] = [];
  Comment: string = '';
  ngOnInit(): void {
    this.loadRecords();

  }


  async loadRecords() {
    let resContracts = await this.contractService.getPendingExpressApproval().toPromise();
    this.Contracts = <ContractDto[]>resContracts.responseData;

    this.showCreatedByColumn = true;
    this.currentUser = this.tokenService.getInfo();

    if (!(this.Contracts[0].createdBy == this.currentUser.profile.email)) { this.showCreatedByColumn = true; }
    if (!(this.Contracts[0].departmentName == this.currentUser.profile.departmentName)) { this.showFunctionColumn = true; }
    this.showFunctionColumn = true;

  }
  async approveExpressRequest() {
    const model: approveContractVm = { id: this.ApproveRequest.id, message: this.Comment, token:'' };

    this.contractService.approveExpressApproval(model).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });
          this. handleCancel();
          this.loadRecords();
          this.close()
        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });
          this. handleCancel();
        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;

        this. handleCancel();
        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }

  async rejectExpressRequest() {
    if (this.Comment === '') {
      this.notification.sendMessage({
        message: 'Comment is required when rejecting request',
        type: NotificationType.error
      });
    }
    else {
      const model: approveContractVm = { id: this.ApproveRequest.id, message: this.Comment, token:'' };

      this.contractService.rejectExpressApproval(model).subscribe({
        next: (data => {
          
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });
          this. handleCancel();
            this.loadRecords();
            this.close()
          }
          else {
  
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });
            this. handleCancel();
          }
  
        }),
        error: ((error: any) => {
          console.log(error.error);
        
  
          this. handleCancel();
          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });
        })
  
      });
    }
  }


  async open(data: ContractDto) {

    this.ViewRequestVisible = true;
    ;
    this.ApproveRequest = data;

  }

  close(): void {
    this.ViewRequestVisible = false;
  }

  cancel(): void {
    return;
  }

  openApproveConfirmationModal(): void {
    this.isApproveConfirmationModalVisible = true;
  }

  openRejectConfirmationModal(): void {
    this.isRejectConfirmationModalVisible = true;
  }

  handleCancel(): void {
    this.isApproveConfirmationModalVisible = false;
    this.isRejectConfirmationModalVisible = false;
  }

}
